<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div
    class="relative flex-25 lg:flex-50 pt-5 lg:pt-8 pb-7 lg:py-2 overflow-hidden"
  >
    <div v-if="index < 2" :class="`${lineStyles} top-0`"></div>
    <data-title
      :text="title"
      :isUmbraco="isUmbraco"
      :theme="theme"
      classes="text-[52px] lg:text-[80px] font-bold lg:leading-[105%] lg:pb-5"
    />
    <rich-text
      v-if="content"
      :text="content"
      :isUmbraco="isUmbraco"
      :theme="theme"
      classes="lg:text-[24px] lg:leading-[150%] lg:pb-5"
    />
    <div :class="`${lineStyles} bottom-0`"></div>
  </div>
</template>

<script lang="ts" setup>
import DataTitle from "@/components/Typography/DataTitle.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import { computed, toRefs } from "vue";

export interface NumberItemProps {
  classes?: string;
  theme: "dark" | "light";
  title: string;
  content?: string;
  index: number;
  isUmbraco?: boolean;
  animateIn: boolean;
}

const props = withDefaults(defineProps<NumberItemProps>(), {
  theme: "light",
  isUmbraco: false,
  animateIn: false,
});

const { theme, title, content, index, isUmbraco, animateIn } = toRefs(props);

const lineStyles = computed(() => {
  const pos = animateIn.value ? "translate-x-0" : "-translate-x-full";
  return `w-[60%] bg-orange absolute left-0 h-3 ${pos} transition-transform duration-500 ease-accelerate`;
});
</script>
